<template>
<div v-if="viewType === 'SETTING'">
  <el-row type="flex" justify="space-between" class="title-bar">
    <div class="title-bar title-h4">선택된 성능 지표</div>
    <el-button @click="openRscSlidingPopup">성능지표 선택</el-button>
  </el-row>
  <el-table :data="selectRscList" height="200px">
    <el-table-column prop="objDefineName" label="관리 구분" />
    <el-table-column prop="objtypeName" label="장비 종류" />
    <el-table-column prop="rscName" label="성능 지표 명" />
  </el-table>
  <w-sliding-popup ref="rscSlidingPopup" title="분석 대상 자원 설정" width="600px" :modal="false" :append-to-body="true">
    <div slot="content" v-loading="loading">
      <div class="mr-b10" style="font-size: 13px;color: #888;">
        * 음영 처리가 된 자원은 [정보시스템 운영관리 지침]에 의거한 필수 관리요소입니다.
      </div>
      <hr class="mr-b20" />
      <div v-for="(rscInfo, index) in rscInfoList" class="mr-b25" :key="rscInfo.objtypeId">
        <div>
          <div class="title-bar title-h3">
            <span>{{ rscInfo.objDefineName }}</span><span v-if="rscInfo.subLabel"> : {{ rscInfo.subLabel }}</span>
          </div>
        </div>
        <el-checkbox-group v-model="checkList[index]" @change="checkChange(index, ...arguments)">
          <el-row :gutter="4">
            <el-col :span="6" v-for="rsc in rscInfo.rscList" :key="rsc.tempKey">
              <el-checkbox class="ellipsis-checkbox" :key="rsc.tempKey" :label="rsc.tempKey">
                <el-tooltip effect="dark" :content="rsc.rscName" placement="bottom">
                  <span class="label required" v-if="DEFAULT_RSC_INFO_LIST.indexOf(rsc.tempKey) > -1">{{ rsc.rscName }}</span>
                  <span class="label" v-else>{{ rsc.rscName }}</span>
                </el-tooltip>
              </el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
        <span v-show="rscInfo.rscList.length === 0">분석 가능한 대상 자원이 없습니다.</span>
      </div>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="applyRscList">확인</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-sliding-popup>
</div>
<div v-else-if="viewType === 'INFO'" class="wrapper">
  <el-form-item v-for="(value, key) in optionInfo" :key="key" :label="value.objDefineName">
    <ul>
      <li v-for="item in value.rscInfoList" :key="item.key">{{ item.rscName }}</li>
    </ul>
  </el-form-item>
</div>
<div v-else class="wrapper">
  <el-form-item v-for="(value, key) in previewOptionInfo" :key="key" :label="value.objDefineName">
    <ul>
      <li v-for="item in value.rscInfoList" :key="item.key">{{ item.rscName }}</li>
    </ul>
  </el-form-item>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import filter from 'lodash/filter';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import reportApi from '@/api/report/report';
import { DEFAULT_RSC_INFO_LIST } from '@/constants/report';

export default {
  name: 'WWatchallResourceComponent',
  props: {
    defaultValue: {
      type: Array,
    },
    defaultSetList: {
      type: Object,
      default: () => {},
    },
    dependentAttrIds: {
      type: String,
      default: () => '',
    },
    viewType: {
      type: String,
      default: () => 'SETTING',
    },
    optionInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      DEFAULT_RSC_INFO_LIST,
      selectRscList: [],
      checkList: [[], [], [], [], []],
      rscInfoList: [],
      previewOptionInfo: {},
    };
  },
  computed: {
    lengthObjList() {
      if (this.viewType === 'SETTING') {
        return this.$parent.$refs[this.dependentAttrIds][0].lengthObjList;
      }
      return null;
    },
  },
  watch: {
    lengthObjList: {
      handler() {
        this.selectRscList = [];
      },
    },
  },
  methods: {
    openRscSlidingPopup() {
      const objParam = this.$parent.$refs[this.dependentAttrIds][0].getData();
      if (objParam !== false) {
        this.loading = true;
        reportApi.getRscInfoList(objParam.WATCHALL_OBJS).then((response) => {
          if (response.data.success) {
            this.rscInfoList = response.data.data;
            if (this.selectRscList) {
              forEach(this.rscInfoList, (item, index) => {
                let selectList = [];
                if (item.objDefineId === 'DBMS' || item.objDefineId === 'FMS_SENSOR' || item.objDefineId === 'VMS_OBJECT') {
                  selectList = filter(this.selectRscList, {
                    objDefineId: item.objDefineId,
                    objtypeId: item.objtypeId,
                  });
                } else {
                  selectList = filter(this.selectRscList, {
                    objDefineId: item.objDefineId,
                  });
                }
                forEach(selectList, (rsc) => {
                  this.checkList[index].push(`${rsc.managetypeId}.${rsc.managetypeKey}.${rsc.rsctypeId}.${rsc.rscId}`);
                });
              });
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '분석 대상 자원', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '분석 대상 자원', false));
        }).finally(() => {
          this.loading = false;
        });
        this.$refs.rscSlidingPopup.visible = true;
      }
    },
    close() {
      this.rscInfoList = [];
      this.checkList = [[], [], [], [], []];
      this.$refs.rscSlidingPopup.close();
    },
    applyRscList() {
      const rscInfoList = [];
      forEach(this.checkList, (item, index) => {
        const tempItem = this.rscInfoList[index];
        forEach(item, (tempKey) => {
          const tempRscInfo = find(tempItem.rscList, ['tempKey', tempKey]);
          rscInfoList.push({
            managetypeId: tempItem.managetypeId,
            objDefineName: tempItem.objDefineName,
            objDefineId: tempItem.objDefineId,
            managetypeKey: tempRscInfo.managetypeKey,
            rsctypeId: tempRscInfo.rsctypeId,
            rsctypeName: tempRscInfo.rsctypeName,
            rscId: tempRscInfo.rscId,
            rscName: tempRscInfo.rscName,
            objtypeId: tempItem.objDefineId === 'DBMS' || tempItem.objDefineId === 'FMS_SENSOR' || tempItem.objDefineId === 'VMS_OBJECT' ? tempItem.objtypeId : null,
            objtypeName: tempItem.objDefineId === 'DBMS' || tempItem.objDefineId === 'FMS_SENSOR' || tempItem.objDefineId === 'VMS_OBJECT' ? tempItem.objtypeName : EMPTY_TEXT,
          });
        });
      });
      this.selectRscList = rscInfoList;
      this.close();
    },
    initData() {
      if (!isNil(this.defaultValue)) {
        this.selectRscList = this.defaultValue;
      } else {
        this.selectRscList = [];
      }
    },
    checkChange(index) {
      if (this.checkList[index].length > 5) {
        this.$message(msgUtil.getCustomMsgData('성능 지표별 최대 5개까지 선택 가능합니다.'));
        this.checkList[index].splice(5, 1);
      }
    },
    getData() {
      const data = [];
      forEach(this.selectRscList, (item) => {
        data.push({
          managetypeId: item.managetypeId,
          managetypeKey: item.managetypeKey,
          rsctypeId: item.rsctypeId,
          rscId: item.rscId,
          rsctypeName: item.rsctypeName,
          rscName: item.rscName,
          objDefineName: item.objDefineName,
          objDefineId: item.objDefineId,
          objtypeId: item.objtypeId,
          objtypeName: item.objtypeName,
        });
      });

      if (data.length === 0) {
        this.$message(msgUtil.getCustomMsgData('성능 지표를 선택해 주십시오.'));
        return false;
      }

      const objList = this.$parent.$refs[this.dependentAttrIds][0].getDetailData().WATCHALL_OBJS;
      for (let i = 0; i < objList.length; i += 1) {
        const item = objList[i];
        let selectRsc = null;
        if (item.objDefineId === 'DBMS' || item.objDefineId === 'FMS_SENSOR' || item.objDefineId === 'VMS_OBJECT') {
          selectRsc = find(data, {
            objDefineId: item.objDefineId,
            objtypeId: item.objtypeId,
          });
        } else {
          selectRsc = find(data, {
            objDefineId: item.objDefineId,
          });
        }
        if (isUndefined(selectRsc)) {
          this.$message(msgUtil.getCustomMsgData('성능 지표가 선택되지 않은 관리 대상이 있습니다.'));
          return false;
        }
      }
      return {
        WATCHALL_RESOURCE: data,
      };
    },
    getDetailData() {
      const data = {};
      forEach(this.selectRscList, (item) => {
        if (isNil(data[item.objDefineId])) {
          data[item.objDefineId] = {
            objDefineName: item.objDefineName,
            rscInfoList: [],
          };
        }
        data[item.objDefineId].rscInfoList.push({
          key: `${item.managetypeId}.${item.managetypeKey}.${item.rsctypeId}.${item.rscId}`,
          rscName: item.rscName,
        });
      });
      return {
        WATCHALL_RESOURCE: data,
      };
    },
    setOptionInfo(defaultValue) {
      this.previewOptionInfo = {};
      this.selectRscList = defaultValue;
      this.previewOptionInfo = this.getDetailData().WATCHALL_RESOURCE;
    },
  },
};
</script>

<style lang="scss">
.ellipsis-checkbox.el-checkbox {
  width:100%;

  .el-checkbox__input {
    line-height: 15px;
  }

  .el-checkbox__label {
    width: calc(100% - 19px);
    vertical-align: middle;
    margin-top: 3px;
    line-height: 15px;

    .label {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 1px;
      line-height: 15px;

      &.required {
        background: #ffedd3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/report/attr/WatchallResourceComponent.vue